import { brandPrimary, nameCircles } from '../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	modal: {
		...CssSelectors.allDescendants(
			{
				maxWidth: '100vw',
			},
			'.modal-overlay-content'
		),
	},
	container: {
		padding: 16,
	},
	importTabbarItem: {
		fontSize: 12,
	},
	importTabbar: {
		height: 35,
	},
	importTabbarContent: {
		paddingTop: 15,
		width: '100%',
	},
	modalContainer: {
		minHeight: 500,
		minWidth: 450,
		display: 'flex',
		flexDirection: 'column',
		gap: 20,
	},
	actions: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-around',
	},
	uploadContainer: {
		minHeight: 400,
		minWidth: 400,
		background: nameCircles,
	},
	importContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		gap: 20,
	},
	header: {
		margin: 0,
		color: brandPrimary,
	},
	csvImportMapping: {
		height: 'calc(100vh - 100px)',
		width: 'calc(100vw - 100px)',
	},
});
